import { render, staticRenderFns } from "./HotkeyDialog.vue?vue&type=template&id=46c68eca&scoped=true&"
import script from "./HotkeyDialog.vue?vue&type=script&lang=js&"
export * from "./HotkeyDialog.vue?vue&type=script&lang=js&"
import style0 from "./HotkeyDialog.vue?vue&type=style&index=0&id=46c68eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c68eca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardTitle,VDialog,VIcon,VListItem,VListItemContent,VListItemIcon})
